import axios from 'axios';
import API_URL from '../config';
import logger from '../utils/logger';


// Get user token from localStorage
const getToken = () => localStorage.getItem('token');

// Set auth token for any request
const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// Get all users (admin only)
export const getAllUsers = async () => {
  try {
    const token = getToken();
    setAuthToken(token);
    
    const response = await axios.get(`${API_URL}/api/users/all`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching all users:', error);
    throw error;
  }
};
